import React from 'react';
import { Redirect } from 'react-router-dom';
import useSessionEntity from '../hooks/useSessionEntity';
import Support from './shared/Support';

export default function Invalid() {
  const company = useSessionEntity('company');
  const cart = useSessionEntity('shopping_cart');
  const redirects = ['declined', 'pending'];

  if (company && company.underwriting_status === 'approved' && !cart) {
    return (<Redirect to="/finish/approved" />);
  }

  if (company && company.underwriting_status === 'approved' && cart) {
    return (<Redirect to="/purchase/terms" />);
  }

  if (company && redirects.includes(company.underwriting_status)) {
    return (<Redirect to={`/finish/${company.underwriting_status}`} />);
  }

  return (
    <div id="content" className="text-center mt-2">
      {!company && <div>
        Something seems to be wrong.  Please contact Credit Key support.
        <Support />
      </div>}
    </div>
  );
}
